import styled from 'styled-components';
import { colors, devices } from '../../../base/styled/variables.styled';
export const HeaderContainer = styled.div `
  border-bottom: 2px solid ${colors.neutral200};

  @media ${devices.tablets} {
    border-bottom: none;
  }
`;
export const MenuContainer = styled.div `
  border-bottom: 1px solid ${colors.neutral200};

  @media ${devices.tablets} {
    display: none;
  }
`;
//# sourceMappingURL=GlobalNavigation.style.js.map